import { CmpFinishPageContent } from "../../../components/organisms/CmpPageContent/cmpFinishContent";
import { CmpTemplates } from "../../../components/template/CmpTemplates";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { request } from "../../../lib/api";
import { GET_USER_INFO, POST_USER_INFO } from "../../../common/query-keys";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userSignState } from "../../../states/user-sign-up";
import { User, userState } from "../../../states/user";
export const CmpFinishPage = (props: any) => {
  const { f7router } = props;
  const userSignUpData = useRecoilValue(userSignState);
  const setUserState = useSetRecoilState(userState);

  // const { mutateAsync: loginUser } = useMutation({
  //   mutationFn: (userInfo: { userId: any; password: any }) => {
  //     return request<{
  //       success: boolean;
  //       message?: string;
  //       accessToken?: string;
  //       refreshToken?: string;
  //       user: User;
  //     }>({
  //       method: "POST",
  //       url: "auth/sign-in",
  //       data: userInfo,
  //     });
  //   },
  //   onSuccess: (res: any) => {
  //     if (res.success) {
  //       writeAccessToken(res?.accessToken!);
  //       writeRefreshToken(res?.refreshToken!);
  //       setUserState(res.user);
  //     } else {
  //       alert(res.message);
  //     }
  //   },
  //   onError: (e) => {
  //     alert(e?.message || "서버요청 에러");
  //   },
  // });

  const { mutateAsync: postUserSignUpData } = useMutation({
    mutationFn: (data: any) => {
      return request({
        method: "POST",
        url: POST_USER_INFO,
        data: data,
      });
    },
    onSuccess: async (res: any) => {
      if (!res.success) {
        alert(res.message);
      } else {
        // queryClient.invalidateQueries({ queryKey: [GET_USER_INFO] });
        // await loginUser({
        //   userId: userSignUpData.userInfo.userId,
        //   password: userSignUpData.userInfo.password,
        // });

        // f7router.back(f7router.history[0], {
        //   force: true,
        // });

        window.location.href = "/";
      }
    },
  });

  const handleConfirm = async () => {
    await postUserSignUpData(userSignUpData);
  };

  return (
    <CmpTemplates pageTitle="회원가입">
      <CmpFinishPageContent handleConfirm={handleConfirm} />
    </CmpTemplates>
  );
};
